// Billing windows are UTC calendar months, so the list is built in UTC — read locally on
// the 1st it would offer a month the API treats as the previous one.
const API_FLOOR = '2024-01';

export const currentMonth = (now = new Date()) => now.toISOString().slice(0, 7);

// A fixed list rather than a free-text or native month input: `<input type="month">` is
// unsupported in Firefox and Safari, where it silently degrades to a text box that can
// emit anything. Choosing from generated options makes an invalid period unreachable.
export function monthOptions(count = 24, now = new Date()) {
  const options = [];
  for (let back = 0; back < count; back += 1) {
    const month = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - back, 1));
    const value = currentMonth(month);
    if (value < API_FLOOR) break;
    options.push({
      value,
      title: month.toLocaleDateString(undefined, {
        month: 'long',
        year: 'numeric',
        timeZone: 'UTC',
      }),
    });
  }
  return options;
}
